import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden" }
const _hoisted_3 = { class: "border-b dark:border-gray-700 mx-4" }
const _hoisted_4 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3" }
const _hoisted_5 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }
const _hoisted_6 = { class: "w-full md:max-w-sm flex-1 md:mr-4" }
const _hoisted_7 = { class: "overflow-x-auto" }
const _hoisted_8 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_9 = {
  class: "px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white",
  scope: "row"
}
const _hoisted_10 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_11 = {
  key: 0,
  class: "bg-green-400 text-white text-xs font-medium px-2.5 py-0.5 rounded dark:bg-primary-900 dark:text-primary-300"
}
const _hoisted_12 = {
  key: 1,
  class: "bg-green-400 text-white text-xs font-medium px-2.5 py-0.5 rounded dark:bg-primary-900 dark:text-primary-300"
}
const _hoisted_13 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_14 = { class: "flex -space-x-4 w-28" }
const _hoisted_15 = { class: "px-4 py-2 font-medium whitespace-nowrap" }
const _hoisted_16 = { class: "flex -space-x-4 w-28" }
const _hoisted_17 = { class: "px-4 py-2 flex justify-end" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  "aria-label": "Table navigation",
  class: "flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
}
const _hoisted_20 = { class: "text-sm font-normal text-gray-500 dark:text-gray-400" }
const _hoisted_21 = { class: "font-semibold text-gray-900 dark:text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center justify-between space-x-4 pt-3" }, [
          _createElementVNode("div", { class: "flex-1 flex items-center space-x-3" }, [
            _createElementVNode("h5", { class: "dark:text-white font-semibold" }, " Users ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("label", {
                class: "text-sm font-medium text-gray-900 sr-only dark:text-white",
                for: "user-search"
              }, "Search", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "user-search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                class: "block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                placeholder: "Search users...",
                type: "search"
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0" }, [
            _createElementVNode("button", {
              class: "flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800",
              type: "button"
            }, [
              _createElementVNode("svg", {
                class: "h-3.5 w-3.5 mr-2",
                fill: "none",
                height: "12",
                viewBox: "0 0 12 12",
                width: "12",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M6 0.75V11.25M0.75 6H11.25",
                  stroke: "white",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                })
              ]),
              _createTextVNode(" Add New User ")
            ])
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Name "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Status "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Email "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Created At "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, [
                _createElementVNode("span", { class: "sr-only" }, "Actions")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user._id || index,
                class: "border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
              }, [
                _createElementVNode("th", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(user.fullName), 1)
                ]),
                _createElementVNode("td", _hoisted_10, [
                  (user.isActive)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Active"))
                    : _createCommentVNode("", true),
                  (!user.isActive)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Inactive"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(user.email), 1)
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(user.createdAt), 1)
                ]),
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(_component_router_link, {
                    to: `/administrator/users/user/${user._id}`,
                    class: "flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                    type: "button"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "w-5 h-5 mr-2",
                        fill: "#000000",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", {
                          id: "SVGRepo_bgCarrier",
                          "stroke-width": "0"
                        }),
                        _createElementVNode("g", {
                          id: "SVGRepo_tracerCarrier",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                          _createElementVNode("title"),
                          _createElementVNode("g", { id: "Complete" }, [
                            _createElementVNode("g", { id: "edit" }, [
                              _createElementVNode("g", null, [
                                _createElementVNode("path", {
                                  d: "M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8",
                                  fill: "none",
                                  stroke: "#000000",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2"
                                }),
                                _createElementVNode("polygon", {
                                  fill: "none",
                                  points: "12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8",
                                  stroke: "#000000",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2"
                                })
                              ])
                            ])
                          ])
                        ])
                      ], -1),
                      _createElementVNode("span", null, "Edit User", -1)
                    ])),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("button", {
                    class: "flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-red-500 bg-white border border-red-400 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                    type: "button",
                    onClick: ($event: any) => (_ctx.deleteUser(user._id))
                  }, _cache[5] || (_cache[5] = [
                    _createStaticVNode("<svg class=\"w-5 h-5 mr-2\" fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"><path d=\"M4 7H20\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path><path d=\"M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path><path d=\"M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></g></svg><span>Delete</span>", 2)
                  ]), 8, _hoisted_18)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("nav", _hoisted_19, [
        _createElementVNode("span", _hoisted_20, [
          _cache[7] || (_cache[7] = _createTextVNode(" Showing ")),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "1-10", -1)),
          _cache[9] || (_cache[9] = _createTextVNode(" of ")),
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.users.length), 1)
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("ul", { class: "inline-flex items-stretch -space-x-px" }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Previous"),
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "w-5 h-5",
                fill: "currentColor",
                viewbox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "clip-rule": "evenodd",
                  d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                  "fill-rule": "evenodd"
                })
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "0")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              "aria-current": "page",
              class: "flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white",
              href: "#"
            }, "1")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "...")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "1")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Next"),
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "w-5 h-5",
                fill: "currentColor",
                viewbox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "clip-rule": "evenodd",
                  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                  "fill-rule": "evenodd"
                })
              ])
            ])
          ])
        ], -1))
      ])
    ])
  ]))
}